import { webBridge } from './bridge';
import { captureCalendarReturn } from './calendarAccounts';
import { createDevBridge } from './devBridge';
import { captureReturnParams, captureSignInReturn } from './webAuth';

/**
 * Köprü, arayüz modüllerinden önce yerleşmeli. main.tsx bu dosyayı arayüzden
 * önce içe aktarıyor; ES modülleri içe aktarma sırasıyla çalıştığı için
 * `window.zabit` App yüklenirken hazır.
 *
 * Google'dan / takvim bağlamadan dönüşün adres parametreleri de burada, ilk
 * çizimden önce okunuyor.
 */
// Önce Google girişinden, sonra takvim bağlamadan dönüş (ikisi de `/baglanti/…`'ye
// geliyor, sekmede saklanan `state` ayırıyor): adresi tamamen değiştiriyorlar —
// sağlayıcının `code`/`error`'u Supabase girişininki sanılmasın.
captureSignInReturn();
captureCalendarReturn();
captureReturnParams();

// Geliştirmede `?demo`: giriş yapmadan örnek verilerle arayüz (bkz. devBridge.ts).
// Yayın derlemesinde `import.meta.env.DEV` false — bu dal ve devBridge pakete girmez.
const demo = import.meta.env.DEV && new URLSearchParams(window.location.search).has('demo');
window.zabit = demo ? createDevBridge(webBridge) : webBridge;
